<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  name: 'App',
  components: {}
}
</script>
<style>
body{
  padding: 0;
  margin: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue